import { useTranslation } from "react-i18next";
import PageRoot from "../../../components/common/form/PageRoot";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
import AllVacancies from "../../../components/corporate/recruitment/AllVacancies";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";

const Vacancies = () => {
  const { t } = useTranslation('common');
  useSitemap();

  return (
    <>
      <Canonical />
      <div className="w-full h-full dark:bg-bgDarkDull bg-white">
        <div className="relative z-[1]">
          <RecruitmentHeader />
          <PageRoot page={t("recruitment.home.all_vacancies")} />
        </div>

        <div id="home">
          <AllVacancies />
        </div>
      </div>
    </>
  );
};

export default Vacancies;